import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import "./assets/css/editcategorymodel.css";

const EditCategory = ({ categoryId, onClose, onUpdated }) => {
  const { baseUrl } = useContext(AppContext);
  const [imgpath, setimgpath] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadImgMsg, setUploadImgMsg] = useState("");
  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [status, setStatus] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    categoryType: "",
    image_path: "",
    description: "",
    metatag: "",
    meta_title: "",
    meta_keyword: "",
    meta_description: "",
    weight: "",
  });
  const [thumbnailFile, setThumbnailFile] = useState(null);

  const admineditCategoryId = "https://htmlgames4u.com/api";
  useEffect(() => {
    const editCategory = async () => {
      if (!categoryId) return;
      const res = await axios.get(`${baseUrl}/category/${categoryId}`);
      if (res) {
        setFormData(res.data);
        setimgpath(res.data.image_path);
      }
    };
    editCategory();
  }, [categoryId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleThumbUpload = async (e) => {
    e.preventDefault();
    if (!thumbnail) {
      return;
    }

    const formData = new FormData();
    formData.append("thumbnail", thumbnail);

    try {
      const res = await axios.post(
        `${baseUrl}/upload-category-thumbnail`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res) {
        setUploadImgMsg("Thumbnail Img upload successfully");
        setUpdateEnabled(true);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    formData.image_path = `/category_thumbnail/${e.target.files[0].name}`;

    setThumbnail(file);
    setThumbnailFile(e.target.files[0]);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (thumbnail) {
      data.append("thumbnail", thumbnail);
    }

    try {
      const res = await axios.put(`${baseUrl}/category/${categoryId}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setStatus("Category updated successfully.");
      setUpdateEnabled(false);
      onUpdated();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="edit_category_model_main">
      <h3>Edit Game</h3>
      <form onSubmit={handleSubmit}>
        <div className="form_field">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Game Name"
          />
        </div>

        <div className="form_field">
          <label>categoryType</label>
          <input
            type="text"
            name="categoryType"
            value={formData.categoryType}
            onChange={handleChange}
            placeholder="Title"
          />
        </div>
        <div className="form_field">
          <label>weight</label>
          <input
            type="text"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
            placeholder="weight"
          />
        </div>
        <div className="form_description">
          <div className="form_field">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Description"
            />
          </div>

          <div>
            <label>Thumbnail: </label>
            <input type="file" accept="image/*" onChange={handleFileChange} />
          </div>
          {preview && (
            <img
              src={preview}
              alt="Thumbnail Preview"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
          )}

          <div className="form_field">
            <label>image_path</label>
            <input
              type="text"
              name="image_path"
              value={formData.image_path}
              readOnly
              onChange={handleChange}
              placeholder="image_path"
            />
          </div>

          <small>Current: {formData.image_path}</small>
          <div>
            <button onClick={handleThumbUpload}>Upload</button>
            <p style={{ color: "green" }}>{uploadImgMsg}</p>
          </div>
        </div>

        <div className="form_field">
          <label>Meta Tag</label>
          <textarea
            name="metatag"
            value={formData.metatag}
            onChange={handleChange}
            placeholder="Enter SEO meta tags..."
            rows="3"
            cols="40"
          />
        </div>

        <div className="form_field">
          <label>Meta Title:</label>
          <input
            name="meta_title"
            type="text"
            value={formData.meta_title}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form_field">
          <label>Meta Keyword:</label>
          <input
            name="meta_keyword"
            type="text"
            value={formData.meta_keyword}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form_field">
          <label>Meta Description:</label>
          <textarea
            name="meta_description"
            value={formData.meta_description}
            onChange={handleChange}
            rows="3"
            cols="40"
            placeholder="Enter SEO meta tags..."
            className="form-control"
          />
        </div>

        <div className="form_btn">
          <button type="submit">Update Game</button>
          <button
            type="button"
            onClick={onClose}
            className="cancle"
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </button>
        </div>
        <div style={{ color: "green", marginTop: "10px" }}>{status}</div>
      </form>
    </div>
  );
};

export default EditCategory;
